module.exports = __webpack_public_path__ + "static/media/ic-operational.8a7f694e.svg";